import type {Placement} from './types';
import {validateAdminKey} from './boards';

export type LayerAction = 'hide'|'restore'|'delete';
export interface LayerActionInput {operation:LayerAction;idempotencyKey:string;worldEpoch:number;expectedRevision:number;confirmation?:string}
export interface DeletedLayer {placement:Placement;revision:number;actor:string;changedAt:string}
export interface DeletedLayers {layers:DeletedLayer[];nextBefore:number|null;worldEpoch:number;purgePending?:boolean}
export interface LayerActionResult {placement:Placement;moderationRevision:number;worldEpoch:number;replayed?:boolean;sourceRetained?:boolean;purgePending?:boolean}

/** Only action identity belongs in an audit receipt, never arbitrary payloads. */
export function canonicalLayerAction(value:unknown):LayerActionInput {
  if(!value||typeof value!=='object'||Array.isArray(value))throw new Error('Invalid layer action.');
  const input=value as LayerActionInput;
  if(!['hide','restore','delete'].includes(input.operation)||!Number.isSafeInteger(input.worldEpoch)||input.worldEpoch<0||!Number.isSafeInteger(input.expectedRevision)||input.expectedRevision<0||(input.confirmation!==undefined&&typeof input.confirmation!=='string'))throw new Error('Invalid layer action.');
  return {operation:input.operation,idempotencyKey:validateAdminKey(input.idempotencyKey),worldEpoch:input.worldEpoch,expectedRevision:input.expectedRevision,...(input.confirmation!==undefined?{confirmation:input.confirmation}:{})};
}

/** Content-free ordering token. Never contains an asset, pose or author. */
export function removedPlacement(value:Placement,revision:number):Placement {
  return {id:value.id,sequence:value.sequence,surfaceId:value.surfaceId,paintOrder:value.paintOrder,
    ...(value.belowPlacementId?{belowPlacementId:value.belowPlacementId}:{}),removed:true,moderationRevision:revision,
    assetId:'',x:0,y:0,width:0,height:0,createdAt:'',playerName:''};
}
export function mergePlacementRows(previous:readonly Placement[],incoming:readonly Placement[]):Placement[]{
  const rows=new Map(previous.map(row=>[row.id,row]));
  for(const row of incoming){const old=rows.get(row.id);if(!old||(row.moderationRevision??0)>=(old.moderationRevision??0))rows.set(row.id,row);}
  return [...rows.values()].sort((a,b)=>a.sequence-b.sequence);
}
